import { PayloadAction } from '@reduxjs/toolkit';
import { timestamp_ms } from '@shared/utils/utils_time';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_reservations_update_active = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.ML_ASSET_RESERVATIONS_UPDATE_ACTIVE,
  payload,
});

export function init_local_ml_asset_reservations_update_active(state: StateMLAsset, action: PayloadAction<string>) {
  let workspace_id = action.payload;

  state.reservations_current_workspace_active_map = new Map();

  let time_now = timestamp_ms();

  for (let reservation of Array.from(state.reservations_map_all.values())) {
    if (reservation.workspace_id != workspace_id) continue;
    if (reservation.expired_at <= time_now) continue; //reservation already expired

    let diffusion_model_reservations_map = state.reservations_current_workspace_active_map.get_value_or_default(reservation.diffusion_model_id, new Map());

    diffusion_model_reservations_map.set(reservation._id, reservation);

    state.reservations_current_workspace_active_map.set(reservation.diffusion_model_id, diffusion_model_reservations_map);
  }

  //need to force re-render
  state.reservations_current_workspace_active_map = new Map(state.reservations_current_workspace_active_map);
}
